<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
    <path
      fill="currentColor"
      d="M11 32.996a1 1 0 0 0-1 1v6.133a1 1 0 0 0 1 1h28a1 1 0 0 0 1-1v-6.133a1 1 0 1 0-2 0v5.133H12v-5.133a1 1 0 0 0-1-1z"
    ></path>
    <path
      fill="currentColor"
      d="M25 9.129a1 1 0 0 0-1 1v21.51l-6.343-6.127a.999.999 0 1 0-1.389 1.438l8.023 7.751.002.002.012.011c.037.036.084.051.124.08.062.045.12.095.192.124a.989.989 0 0 0 .756 0c.067-.027.12-.074.178-.115.046-.031.098-.05.139-.09l8.036-7.765a1 1 0 0 0-1.391-1.438L26 31.639v-21.51a1 1 0 0 0-1-1z"
    ></path>
  </svg>
</template>
